import {createButton} from "./create/create-button";
import {createList} from "./create/create-list";
import {createListItem} from "./create/create-list-item";
import {createSvg} from "./create/create-svg";

export const renderPaginator = (container, pageCount, activePage, onClickPageHandler) => {
  container.innerHTML = ``;

  if (!pageCount) {
    return;
  }

  if (+pageCount <= 1) {
    return;
  }

  if (+activePage !== 1) {
    const prevPageButtonElement = createButton(`Предыдущая`, `paginator__button paginator__button--prev`);
    container.append(prevPageButtonElement);
    const svg = createSvg(``, `10`, `10`, `sienge/img/sprite.svg#arrow-small`);
    prevPageButtonElement.append(svg);

    prevPageButtonElement.addEventListener(`click`, () => {
      onClickPageHandler(+activePage - 1);
      // setActivePage(+activePage - 1);
      // getItemsData();
    });
  }

  // список страниц
  const paginatorListElement = createList(`paginator__list`);
  container.append(paginatorListElement);

  let isRenderActive = false;
  let countPageAfterActivePage = 0;
  let countPageBeforeActivePage = 0;
  let isRender = true;

  new Array(pageCount)
    .fill(``)
    .forEach((numberPage, i) => {
      const page = i + 1;
      const isActive = +activePage === +page;
      if (isActive) {
        isRenderActive = true;
      }
      if (!isRenderActive) {
        countPageBeforeActivePage += 1;
      }
      if (isRenderActive) {
        countPageAfterActivePage += 1;
      }

      if (+activePage - countPageBeforeActivePage === 2) {
        isRender = true;
      }

      if (isRender || +pageCount === page || page === 1) {
        let pageButtonElement = null;

        if (page === 1 || +pageCount === +page || (!isRenderActive && +activePage - countPageBeforeActivePage < 4) || (isRenderActive && (countPageAfterActivePage < 4 || page === pageCount - 1))) {
          pageButtonElement = createButton(page, `paginator__button paginator__button--number ${isActive ? `paginator__button--active` : ``}`);
          pageButtonElement.dataset.page = page;
        } else {
          pageButtonElement = createButton(`...`, `paginator__button paginator__button--number ${isActive ? `paginator__button--active` : ``}`);
          pageButtonElement.dataset.page = page;
          isRender = false;
        }

        pageButtonElement.addEventListener(`click`, () => {
          onClickPageHandler(page);
          // setActivePage(page);
          // getItemsData();
        });

        const liItemElement = createListItem(`paginator__page`);
        paginatorListElement.append(liItemElement);
        liItemElement.append(pageButtonElement);
      }
    });

  if (+activePage !== +pageCount) {
    const nextPageButtonElement = createButton(`Следующая`, `paginator__button paginator__button--next`);
    container.append(nextPageButtonElement);
    const svg = createSvg(``, `10`, `10`, `sienge/img/sprite.svg#arrow-small`);
    nextPageButtonElement.append(svg);

    nextPageButtonElement.addEventListener(`click`, () => {
      onClickPageHandler(+activePage + 1);

      // setActivePage(+activePage + 1);
      // getItemsData();
    });
  }
};
